
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
    COURSEINTERVENTION_ACTION,
    FETCH_COURSEINTERVENTION,
    ADD_COURSEINTERVENTION,
    GET_COURSEINTERVENTION,
    EDIT_COURSEINTERVENTION,
    DELETE_COURSEINTERVENTION,
} from 'Actions/types';

import { NotificationManager } from 'react-notifications';
/**
 * Course Intervention Actions
 */

    export const fetchCourseIntervention = (id) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:COURSEINTERVENTION_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/fetchcourseintervention', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_COURSEINTERVENTION, payload: resdata.data});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const addCourseIntervention = (data, id) =>{
    
        var payload={
            "student":id,
            "sgdate":data.target.seldate.value,
            "coachname":data.target.coachname.value,
            "observation":data.target.observation.value,
            "workinprocess":data.target.workin.value
        }
        return (dispatch) => { 
            dispatch({ type:COURSEINTERVENTION_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/addcourseintervention', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    fetchCourseIntervention(id)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: ADD_COURSEINTERVENTION});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const getCourseIntervention = (id) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:COURSEINTERVENTION_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/getcourseintervention', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: GET_COURSEINTERVENTION, payload: resdata.data[0]});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const editCourseIntervention = (data, id, stdid) =>{
    
        var payload={
            "id":id,
            "sgdate":data.target.seldate.value,
            "coachname":data.target.coachname.value,
            "observation":data.target.observation.value,
            "workinprocess":data.target.workin.value
        }
        return (dispatch) => { 
            dispatch({ type:COURSEINTERVENTION_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/editcourseintervention', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    fetchCourseIntervention(stdid)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: EDIT_COURSEINTERVENTION});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }


    export const deleteCourseIntervention = (id, stdid) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:COURSEINTERVENTION_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/deletecourseintervention', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    fetchCourseIntervention(stdid)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: DELETE_COURSEINTERVENTION});                    
                }
                
                
            });
        
        }
    }


    